import { Button } from '@/components/ui/button'
import { Loader2, Wallet } from 'lucide-react'
import { useTranslations } from 'next-intl'

type WalletButtonProps = {
	onClick: () => void
	isPending: boolean
	step: 'idle' | 'connecting' | 'signing' | 'verifying'
	disabled?: boolean
}

const stepKeys: Record<WalletButtonProps['step'], string> = {
	idle: 'connectWallet',
	connecting: 'connecting',
	signing: 'signing',
	verifying: 'signingIn',
}

export function WalletButton({ onClick, isPending, step, disabled }: WalletButtonProps) {
	const t = useTranslations('auth')

	return (
		<Button
			onClick={onClick}
			disabled={isPending || disabled}
			variant="outline"
			className="min-h-[48px] w-full rounded-[12px] border-brand-gray bg-transparent py-[15px] font-medium text-[16px] text-white leading-[100%] hover:bg-brand-gray/10"
		>
			{isPending ? (
				<>
					<Loader2 className="mr-2 h-4 w-4 animate-spin" />
					{t(stepKeys[step])}
				</>
			) : (
				<>
					<Wallet className="mr-2 h-4 w-4" />
					{t(stepKeys[step])}
				</>
			)}
		</Button>
	)
}
